export const config = {
    marketsQuery: {
        two: {
            maxWidth: 699
        },
        three: {
            minWidth: 700,
            maxWidth: 799
        },
        four: {
            minWidth: 800,
            maxWidth: 924
        }
    }
}
